import styles from "./footer.module.css";
import {
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import { BsYoutube } from "react-icons/bs";
import { MdLocationOn, MdPhone, MdEmail } from "react-icons/md";
import { HeadingTitle, Image } from "../../shared/index";
import { Link } from "react-router-dom";

const Footer = () => {
  const productLinks = [
    { name: "Categories", path: "/categories" },
    { name: "Shop", path: "/shop" },
    { name: "About Us", path: "/about" },
    { name: "Contact", path: "/contact" },
  ];

  const policyLinks = [
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Refund Policy", path: "/refund-policy" },
    { name: "Terms & Conditions", path: "/terms-and-conditions" },
    { name: "Shipping Policy", path: "/shipping-policy" },
  ];

  const socialIcons = [
    {
      icon: <FaFacebookF />,
      label: "Facebook",
      url: "https://www.facebook.com/p/GDRB-Technologies-Pvt-Ltd-100088258881230/",
    },
    {
      icon: <FaInstagram />,
      label: "Instagram",
      url: "https://www.instagram.com/gdrbtechnologies/",
    },
    {
      icon: <BsYoutube />,
      label: "YouTube",
      url: "https://www.youtube.com/@gdrbtechnologies",
    },
  ];

  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerWrapper}>

        {/* LOGO + SOCIAL */}
        <div className={styles.footerSection}>
          <div className={styles.logoBox}>
            <Image
              src="/Pharmacy_logo_1.svg"
              alt="Anuradha Logo"
              className={styles.logo}
            />
          </div>

          <p className={styles.description} style={{color:"white"}}>
            GDRB Technologies creates tailored IT solutions,
            blending business insight with technology expertise.
          </p>

          <div className={styles.socialSection}>
            <span className={styles.socialTitle}>Follow Us</span>

            <div className={styles.socialIcons}>
              {socialIcons.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialIcon}
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* OUR STORES */}
        <div className={styles.footerSection}>
          <HeadingTitle
            text="OUR STORES"
            style={styles.sectionTitle}
          />

          <ul className={styles.linkList}>
            {productLinks.map((item) => (
              <li key={item.name}>
                <Link to={item.path} className={styles.link}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* SHOP CATEGORIES */}
        <div className={styles.footerSection}>
          <HeadingTitle
            text="SHOP CATEGORIES"
            style={styles.sectionTitle}
          />

          <ul className={styles.linkList}>
            {policyLinks.map((item) => (
              <li key={item.name}>
                <Link to={item.path} className={styles.link}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* CONTACT */}
        <div className={styles.footerSection}>
          <HeadingTitle
            text="ABOUT US"
            style={styles.sectionTitle}
          />

          <div className={styles.contactInfo}>
            <div className={styles.contactItem}>
              <MdLocationOn className={styles.contactIcon} />
              <span className={styles.contactText}  style={{color:"white"}}>
                3rd Floor, Opp: HDFC Bank, Plot No. 98,
                Venkateshwara Enclave, Suchitra X Road,
                Hyderabad - 500067
              </span>
            </div>

            <div className={styles.contactItem}>
              <MdPhone className={styles.contactIcon} />
              <a style={{color:"white"}}
    href="tel:+918886060799"
    className={styles.contactText}
  >
     +91 8886060799
  </a>
            </div>

            <div className={styles.contactItem}>
              <MdEmail className={styles.contactIcon} />
               <a style={{color:"white"}}
      href="https://mail.google.com/mail/?view=cm&fs=1&to=info@gdrbtechnologies.com"
      target="_blank"
      rel="noopener noreferrer"
    >
    info@gdrbtechnologies.com 
    </a> 
            </div>
          </div>
        </div>

      </div>

      <div className={styles.footerBottom}>
        <p>
         Copyright © {year} GDRB Technologies Pvt Ltd. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;